import { UpperCasePipe } from '@angular/common';
import type { InputSignal } from '@angular/core';
import { Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { AvatarComponent, BadgeComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-edit-member-header',
  imports: [AvatarComponent, BadgeComponent, TranslatePipe, UpperCasePipe],
  templateUrl: './edit-member-header.component.html',
  styleUrl: './edit-member-header.component.less',
})
export class EditMemberHeaderComponent {
  public avatarThumbUrl: InputSignal<string> = input.required();
  public name: InputSignal<string> = input.required();
  public isOwner: InputSignal<boolean> = input.required();
  public isDeactivated: InputSignal<boolean> = input.required();
  public email: InputSignal<string> = input.required();
}
